// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.floater_table__body div[data-v-4b3e8c7e] {\n  height: initial;\n}\n.tabledivreset[data-v-4b3e8c7e]:focus{\n  outline: none;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
